module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/featured-section@1x.02a824a.gif";